export enum StationType {
  TLC_CABINET = 'TLC_CABINET',

  GENERIC = 'GENERIC',
}
